import React from "react";
import { Outlet } from "react-router-dom";
import { usePortal } from "../../context/PortalsContext";
import { HttpErrorPage } from "../../pages/ErrorPages/HttpErrorPage";

export const TranslationRouteGuard: React.FC = () => {
  const { portals } = usePortal();
  const selectedPortal = portals.selectedPortal;

  const canManageTranslation =
    !!selectedPortal?.isMain || !!selectedPortal?.customTranslation;

  if (!canManageTranslation) {
    return <HttpErrorPage status={401} isNested />;
  }

  return <Outlet />;
};
